import { Divider } from '@mui/material';
import TextField from '@mui/material/TextField';
import { MemreButton, MemreFlexBox, MemreModal, MemreSortableList } from 'components/core';
import { useState } from 'react';
import { Sequences } from 'services/useItem.service/interactions';
import { useAuthoringContext } from '../AuthoringContext';
import AttachInstructionalItem from '../components/AttachInstructionalItem';
import ImageUploadModal from '../components/ImageUpload/ImageUploadModal';
import Step from '../components/Step';

export default function SequenceEl() {
  const sequences = useAuthoringContext()?.item as Sequences;
  const [modalContent, setModalContent] = useState<JSX.Element | null>(null);

  const sortedItems = sequences.steps;

  const handleOrder = (newOrder) => {
    const facetIdOrder = newOrder.map((id) => sequences.steps.find((step) => step.id === id)?.id);
    sequences.order(facetIdOrder);
  };

  const handleAddImage = (addImageMethod) => {
    setModalContent(<ImageUploadModal addImageMethod={addImageMethod} close={() => setModalContent(null)} />);
  };

  return (
    <MemreFlexBox
      direction="column"
      gap={2}
      sx={{
        p: 2,
        pl: 0,
        width: '100%',
      }}
    >
      <TextField
        label="Title"
        variant="outlined"
        value={sequences.title.text}
        onChange={(e) => sequences.title.update(e.target.value)}
      />
      <Divider sx={{ width: '100%', m: 0.5 }} />
      <MemreSortableList
        restrictAxis="y"
        onReorder={handleOrder}
        items={sortedItems}
        render={(item, dragHandle) => (
          <Step
            dragHandle={dragHandle}
            text={item.text}
            id={item.id}
            deleteStep={item.delete}
            image={item.image}
            sound={item.sound}
            setText={item.update}
            deleteImage={item.image.delete}
            handleAddImage={handleAddImage}
            addSound={item.sound.add}
            deleteSound={item.sound.delete}
          />
        )}
      />
      <MemreButton variant="text" text="Add Step" size="small" iconName="plus" onClick={sequences.add} />

      <Divider sx={{ width: '100%', m: 0.5, mt: 2 }} />

      {sequences?.id && <AttachInstructionalItem itemId={sequences.id} />}

      <MemreModal padding={0}>{modalContent}</MemreModal>
    </MemreFlexBox>
  );
}
